import type { IconData } from '@stacksjs/iconify-core'

export const designArtboardShapes: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.95 3.05H32v1.52h-3.05Zm0 24.38H32v1.52h-3.05ZM27.43 0h1.52v3.05h-1.52Zm0 28.95h1.52V32h-1.52Zm0-24.38H4.57v22.86h22.86Zm-1.52 21.34H6.1V6.1h19.81Z\"/><path fill=\"currentColor\" d=\"M13.72 24.38h10.66V13.71H13.72Zm1.52-9.14h7.62v7.62h-7.62Z\"/><path fill=\"currentColor\" d=\"M9.15 18.29h1.52v1.52h1.52v-7.62h7.62v-1.52h-1.52V9.14h-1.53V7.62h-6.09v1.52H9.15v1.53H7.62v6.09h1.53zM3.05 0h1.52v3.05H3.05Zm0 28.95h1.52V32H3.05ZM0 3.05h3.05v1.52H0Zm0 24.38h3.05v1.52H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default designArtboardShapes
